<!--
  ~ Copyright (c) 2020 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<div class="kit-load-spinner"></div>